{
  "toast": {
    "created": "¡Quiz creado correctamente!",
    "createError": "Error al crear el quiz",
    "updated": "¡Quiz actualizado correctamente!",
    "updateError": "Error al actualizar el quiz",
    "deleted": "¡Quiz eliminado correctamente!",
    "deleteError": "Error al eliminar el quiz",
    "started": "¡Quiz iniciado!",
    "startError": "Error al iniciar el quiz",
    "passed": "¡Felicidades! Aprobaste con un {{score}}%!",
    "failed": "Obtuviste un {{score}}%. ¡Inténtalo de nuevo!",
    "submitError": "Error al enviar el quiz"
  },
  "questionType": {
    "multipleChoice": "Opción múltiple",
    "trueFalse": "Verdadero/Falso",
    "essay": "Desarrollo"
  },
  "player": {
    "questionNumber": "Pregunta {{number}}",
    "points": "{{points}} pts",
    "hint": "Pista:",
    "previous": "Anterior",
    "submitting": "Enviando...",
    "finish": "Finalizar quiz",
    "next": "Siguiente",
    "answeredCount": "Respondidas: <highlight>{{answered}}</highlight> de {{total}}",
    "passingScore": "Nota mínima: <highlight>{{score}}%</highlight>",
    "exit": "Salir del quiz"
  },
  "results": {
    "passedTitle": "¡Felicidades!",
    "failedTitle": "¡Sigue intentándolo!",
    "passedDescription": "¡Aprobaste el quiz!",
    "failedDescription": "¡No te rindas! Repasa el contenido e inténtalo de nuevo.",
    "yourScore": "Tu nota",
    "passingScore": "Nota mínima",
    "correct": "Aciertos",
    "wrong": "Errores",
    "accuracy": "Precisión",
    "time": "Tiempo",
    "completedAt": "Completado el {{date}}",
    "completedAtFormat": "d 'de' MMMM 'de' yyyy 'a las' HH:mm",
    "review": "Revisión de las preguntas",
    "answerCorrect": "Correcta",
    "answerIncorrect": "Incorrecta",
    "pointsOf": "{{points}}/{{total}} pts",
    "explanation": "Explicación:",
    "backToCourse": "Volver al curso",
    "viewCertificate": "Ver certificado",
    "retry": "Intentar de nuevo",
    "retryInfo": "Puedes intentarlo de nuevo. Límite de intentos: {{max}}",
    "noRetries": "⚠️ No es posible volver a intentarlo. Repasa el contenido del curso."
  },
  "studentPlayer": {
    "timeUp": "¡Se acabó el tiempo! Enviando respuestas...",
    "starting": "Iniciando quiz...",
    "loadError": "Error al cargar el quiz",
    "reloadHint": "Intenta recargar la página",
    "questionOf": "Pregunta {{number}} de {{total}}",
    "answered_one": "{{count}} respondida",
    "answered_zero": "{{count}} respondidas",
    "answered_other": "{{count}} respondidas",
    "progress": "Progreso",
    "question": "Pregunta {{number}}",
    "points_one": "{{count}} punto",
    "points_zero": "{{count}} puntos",
    "points_other": "{{count}} puntos",
    "yourAnswer": "Tu respuesta:",
    "answerPlaceholder": "Escribe tu respuesta aquí...",
    "essayHint": "Sé detallado en tu respuesta. Las preguntas de desarrollo se corrigen manualmente.",
    "previous": "Anterior",
    "answeredOf": "{{answered}}/{{total}} preguntas respondidas",
    "next": "Siguiente",
    "finish": "Finalizar quiz",
    "instructions": "Instrucciones",
    "timeAlmostUp": "¡Se acaba el tiempo!",
    "timeRemaining": "Solo quedan {{time}}"
  },
  "studentResults": {
    "perfect": {
      "title": "🏆 ¡PERFECTO!",
      "subtitle": "¡Acertaste todas las preguntas!"
    },
    "excellent": {
      "title": "🌟 ¡EXCELENTE!",
      "subtitle": "¡Muy buen resultado!"
    },
    "passed": {
      "title": "✅ ¡APROBADO!",
      "subtitle": "¡Aprobaste este quiz!"
    },
    "failed": {
      "title": "❌ SUSPENDIDO",
      "subtitle": "¡Sigue estudiando e inténtalo de nuevo!"
    },
    "correctOf": "{{correct}}/{{total}} preguntas correctas",
    "passingScore": "Nota mínima",
    "timeSpent": "Tiempo empleado",
    "correct": "Aciertos",
    "pointsEarned": "¡+{{points}} puntos conseguidos!",
    "review": "Revisión de las respuestas",
    "question": "Pregunta {{number}}",
    "answerCorrect": "Correcta",
    "answerIncorrect": "Incorrecta",
    "yourAnswerBadge": "Tu respuesta",
    "yourAnswer": "Tu respuesta:",
    "essayNote": "* Las preguntas de desarrollo se corrigen manualmente",
    "explanation": "Explicación",
    "retry": "Intentar de nuevo",
    "continue": "Seguir estudiando",
    "noRetries": "Este quiz no permite reintentos. Repasa el material y sigue estudiando.",
    "tips": {
      "title": "Consejos para mejorar",
      "review": "<bold>Repasa el material:</bold> Parece que necesitas dedicar más tiempo a este contenido. Vuelve a ver las clases y los materiales complementarios.",
      "almost": "<bold>Casi lo tienes:</bold> Tienes una buena base, pero puedes mejorar. Céntrate en las áreas donde fallaste y practica más.",
      "goodJob": "<bold>Buen trabajo:</bold> ¡Dominas bien el contenido! Con un poco más de atención a los detalles, puedes alcanzar la excelencia.",
      "time": "<bold>Gestión del tiempo:</bold> Usaste casi todo el tiempo disponible. Practica más para responder con más agilidad."
    }
  }
}
